import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ProductSlider = ({ FeaturedCard }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [cardsPerView, setCardsPerView] = useState(4);
  const navigate = useNavigate();

  const featuredCards = Array.isArray(FeaturedCard) ? FeaturedCard : [];

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) setCardsPerView(4);
      else if (window.innerWidth >= 640) setCardsPerView(2);
      else setCardsPerView(1);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => setCurrentIndex(0), [cardsPerView]);

  const maxIndex = Math.max(
    0,
    Math.ceil(featuredCards.length / cardsPerView) - 1,
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
    }, 20000);
    return () => clearInterval(interval);
  }, [maxIndex]);

  const goToNext = () =>
    setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));

  const goToPrev = () =>
    setCurrentIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));

  const handleProductClick = (product) => {
    navigate(`/Details/${product.id}`, { state: { product } });
  };

  // --- touch/swipe handling ---
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const minSwipeDistance = 50;

  const handleTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStart === null || touchEnd === null) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      goToNext();
    } else if (isRightSwipe) {
      goToPrev();
    }

    setTouchStart(null);
    setTouchEnd(null);
  };

  return (
    <div className="slider-wrapper">
      <div className="slider-container">
        <div className="slider-box">
          <div className="slides-overflow">
            <div
              className="slides-track"
              style={{ transform: `translateX(-${currentIndex * 100}%)` }}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            >
              {Array.from({ length: maxIndex + 1 }).map((_, slideIndex) => (
                <div key={slideIndex} className="slide-group">
                  {featuredCards
                    .slice(
                      slideIndex * cardsPerView,
                      (slideIndex + 1) * cardsPerView,
                    )
                    .map((product) => (
                      <div
                        key={product.id}
                        onClick={() => handleProductClick(product)}
                        className="product-card"
                      >
                        <div className="product-image">
                          <img src={product.itemPhotos[0]} alt="" />
                        </div>
                        <div className="dis">
                          <h2 className="product-title">{product.item_name}</h2>
                          <p className="product-price">
                            K{product.price || product.variants[0]?.price}
                          </p>
                        </div>
                      </div>
                    ))}
                </div>
              ))}
            </div>
          </div>

          <div className="navigation">
            <button onClick={goToPrev} className="nav-button">
              ‹
            </button>
            <div className="dots-container">
              {Array.from({ length: maxIndex + 1 }).map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`dot ${index === currentIndex ? "active" : "inactive"}`}
                />
              ))}
            </div>
            <button onClick={goToNext} className="nav-button">
              ›
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductSlider;
